import { t } from '../../i18n/i18n';
import './StatusFilterChips.scss';

/**
 * Approved/Processing/Rejected filter row with counts, shared by every
 * Affiliate request-history screen (Giveaway, Personal Account, ...).
 * Extracted once Personal Account needed the exact same chips as Giveaway.
 *
 * @param {{
 *   counts: { label: string, count: number, tone: 'success' | 'info' | 'danger' }[],
 *   value: string | null,
 *   onChange: (label: string | null) => void,
 * }} props
 */
export default function StatusFilterChips({ counts, value, onChange }) {
  return (
    <div className="status-filter-chips">
      {counts.map((s) => (
        <button
          key={s.label}
          type="button"
          className={`status-filter-chip status-filter-chip--${s.tone}${
            value === s.label ? ' is-active' : ''
          }`}
          onClick={() => onChange(value === s.label ? null : s.label)}
        >
          {t(s.label)}
          <span className="status-filter-chip__count">{s.count}</span>
        </button>
      ))}
    </div>
  );
}
